export const translations = {
    en: {
        signUp: "Sign up",
        dataVv: "current",
        contactForm: {
            title: "Contact",
            fullName: {
                title: "Full Name",
                placeholder: "Full name",
            },
            phoneNumber: {
                title: "Phone",
                placeholder: "Phone",
            },
            email: {
                title: "E-mail",
                placeholder: "E-mail",
            },
            confirmEmail: {
                title: "Confirm e-mail",
                placeholder: "Confirm e-mail",
            },
            validationMessage: {
                phoneNumberRequired: "Please enter your phone number.",
                correctPhoneNumber: "Please provide a valid phone number.",
                ensureNotEmail: "Full name must not contain @.",
                fullNameLength: "Full name must be minimum 2 names long.",
                confirmEmail: "Enter same e-mail"
            }
        },
        infoForm: {
            title: "Info",
            cpr: {
                title: "Social security number (CPR)",
                placeholder: "190195-1234",
            },
            address: {
                title: "Address",
                placeholder: "Address",
                selectedLabel: "Selected address",
                clearLabel: "Clear address",
            },
            street: {
                title: "Street",
                placeholder: "Street",
            },
            houseNumber: {
                title: "Number",
            },
            houseLetter: {
                title: "Letter",
            },
            houseFloor: {
                title: "Floor",
            },
            placement: {
                title: "Placement",
            },
            zipCode: {
                title: "Zip code",
                placeholder: "Zip code",
            },
            city: {
                title: "City",
                placeholder: "City",
            },
            country: {
                title: "Country",
            },
            customAddress: {
                switchLabel: "Can't find your address or do you live in another country?",
                switchToggledLabel: "Search for address in Denmark"
            },
            helpBenefits: {
                switchLabel: "Yes, I receive cash benefits.",
                switchHeader: "Are you currently receiving any cash assistance?"
            },
            retirementSection:{
                title: "Are you currently receiving any of the following?",
            },
            retirementPension: {
                switchLabel: "Early retirement pension",
            },
            civilServantPension: {
                switchLabel: "Civil servant pension",
            },
            benefits: {
                switchLabel: "Preretirement benefits (efterløn)",
                pensionFullDate: {
                    title: "On which date will you stop receiving preretirement benefits (efterløn)?",
                    placeholder: "Pick or type end date for receiving preretirement benefits - ex. 04.10.2023"
                }
            },
            validationMessage: {
                validAddress: "Fill your address",
                correctCpr: "CPR must be filled out correctly."
            }
        },
        confirmForm: {
            title: "Confirm your information",
            subtitle: "Check to see if your information is correct.",
            editContactButton: "Change contact",
            editInfoButton: "Change info",
            employedSince: "Ansat siden "
        },
        common: {
            emptyOption: "Choose...",
            edit: "Change"
        },
        giftSelector: {
            title: "Choose your sign up gift",
            dismissGift: "I don't want a gift"
        },
        educationForm: {
            title: "Education information",
            educationInstitute: {
                title: "Place of education",
                placeholder: "Choose education place",
                notListed: "My place of education is not on the list",
            },
            educationLevel: {
                title: "Level of Education",
                description: "If you're a student, choose the education you are currently enrolled in. If you've graduated, choose your most recently completed education.",
                dataVv: "Please select your level of education",
            },
            educationSubject: {
                title: "Subject",
                placeholder: "Choose the relevante subject area for your education",
            },
            startDate: {
                title: "Start date",
                placeholder: "End date of your education?",
            },
            endDate: {
                title: "Date of completion",
                placeholder: "Fill out date",
            },
            glMember: {
                title: "Are you a member of GL?",
                description: "If you are a member of GL, DM will make sure your membership is transferred. If you are a member of an other union, you need to terminate you membership on your own.",
                label: "Yes, I am a member at GL - Gymnasielærerne",
            },
            validationMessage: {
                dateMustBeHigher: "must be later than the start date.",
            }
        },
        workForm: {
            title: "Work",
            dmEmploymentTypes: {
                fullTime: "Full time (more than 18 hours/week)",
                partTime: "Part time (18 hours/week or less)",
                flexTime: "Flex job",
                selfEmployed: "Self-employed",
                freelanceFullTime: "Freelancer full-time",
                freelancePartTime: "Freelancer part-time"
            },
            dmEmploymentType: {
                title: "Employment type",
                placeholder: "Select employment type"
            },
            combinator: {
                title: "Do you combine freelance and employed work?",
                label: "Yes, I work both as a freelancer/self‑employed and as an employee"
            },
            workTitle: {
                title: "Title",
                placeholder: "Enter title"
            },
            cvr: {
                title: "CVR number",
                placeholder: "Enter CVR number"
            },
            workingArea: {
                title: "Working area",
                defaultOption: "Select working area"
            },
            startDate: {
                title: "Start date",
                placeholder: "Select start date for employment"
            },
            workplaces: {
                title: "Workplace",
                placeholder: "Type to search",
                addLabel: "Add workplace",
                backLabel: "Back to job search",
                errorMessage: "Search and select from list"
            },
            employedUnderAcAgreement: {
                title: "Are you employed under AC agreement?",
                label: "Yes, I am employed under the AC agreement"
            },
            managerWithPersonnel: {
                title: "Are you a manager with personnel responsibility?",
                label: "Yes, I am a manager with personnel responsibility"
            },
            jobPosition: {
                title: "Position",
                placeholder: "Select position"
            },
            companyName: {
                title: "Company name",
                placeholder: "Enter company name"
            },
            companyAddress: {
                title: "Address",
                placeholder: "Enter company address"
            },
            workplaceName: {
                title: "Workplace",
                placeholder: "Enter workplace name",
            },
            workplaceAddress: {
                title: "Address",
                placeholder: "Enter workplace address",
            },
            cvrSearch: {
                jobPosition: {
                    title: "There are several workplaces in the selected company",
                    placeholder: "Select your workplace from the list",
                    label: "We found a company with this CVR number",
                    notFoundLabel: "Can't find your workplace on the list?",
                    backToListLabel: "See the list of workplaces"
                }
            }
        }
    },
    da: {
        signUp: "Meld dig ind",
        dataVv: "Feltet",
        contactForm: {
            title: "Kontakt",
            fullName: {
                title: "Fulde navn",
                placeholder: "Indtast navn",
            },
            phoneNumber: {
                title: "Telefonnummer",
                placeholder: "Indtast telefonnummer",
            },
            email: {
                title: "E-mail",
                placeholder: "Indtast e-mail",
            },
            confirmEmail: {
                title: "Bekræft e-mail",
                placeholder: "Gentag e-mail",
            },
            validationMessage: {
                phoneNumberRequired: "Indtast dit telefonnummer.",
                correctPhoneNumber: "Indtast gyldigt telefonnummer.",
                ensureNotEmail: "Fulde navn kan ikke indeholde @.",
                fullNameLength: "Fulde navn skal minimum indeholde 2 navne.",
                confirmEmail: "Indtast den samme e-mail"
            }
        },
        infoForm: {
            title: "Oplysninger",
            cpr: {
                title: "CPR-nummer",
                placeholder: "190195-1234",
            },
            address: {
                title: "Adresse",
                placeholder: "Indtast adresse",
                selectedLabel: "Valgt adresse",
                clearLabel: "Ryd adresse",
            },
            street: {
                title: "Vej",
                placeholder: "Indtast vejnavn",
            },
            houseNumber: {
                title: "Nummer",
            },
            houseLetter: {
                title: "Bogstav",
            },
            houseFloor: {
                title: "Etage",
            },
            placement: {
                title: "Side",
            },
            zipCode: {
                title: "Postnummer",
                placeholder: "Indtast postnummer"
            },
            city: {
                title: "By",
                placeholder: "Indtast by",
            },
            country: {
                title: "Land",
            },
            customAddress: {
                switchLabel: "Kan du ikke finde din adresse eller bor du i udlandet?",
                switchToggledLabel: "Søg efter dansk adresse"
            },
            helpBenefits: {
                switchLabel: "Ja, jeg modtager kontanthjælp",
                switchHeader: "Modtager du i øjeblikket kontanthjælp?"
            },
            retirementSection:{
                title: "Modtager du i øjeblikket nogen af følgende?",
            },
            retirementPension: {
                switchLabel: "Førtidspension",
            },
            civilServantPension: {
                switchLabel: "Tjenestemandspension",
            },
            benefits: {
                switchLabel: "Efterløn",
                pensionFullDate: {
                    title: "Hvilken dato slutter du med at modtage efterløn?",
                    placeholder: "Vælg eller indtast slutdato for efterløn – f.eks. 04.10.2023"
                }
            },
            validationMessage: {
                validAddress: "Udfyld din adresse",
                correctCpr: "CPR skal være udfyldt korrekt."
            }
        },
        confirmForm: {
            title: "Bekræft dine oplysninger",
            subtitle: "Tjek efter om oplysningerne er korrekte.",
            editContactButton: "Rediger kontakt",
            editInfoButton: "Rediger oplysninger",
            employedSince: "Ansat siden "
        },
        common: {
            emptyOption: "Vælg...",
            edit: "Rediger"
        },
        giftSelector: {
            title: "Vælg din indmeldelsesgave",
            dismissGift: "Jeg ønsker ikke en gave"
        },
        educationForm: {
            title: "Uddannelsesinformation",
            educationInstitute: {
                title: "Uddannelsessted",
                placeholder: "Vælg uddannelsessted",
                notListed: "Uddannelsessted er ikke på listen",
            },
            educationLevel: {
                title: "Niveau",
                description: "Hvis du er studerende, vælg den uddannelse du er i gang med. Hvis du er færdiguddannet, vælg din senest afsluttede uddannelse.",
                dataVv: "Vælg dit uddannelsesniveau",
            },
            educationSubject: {
                title: "Fagområde",
                placeholder: "Angiv det fagområde der passer bedst på din uddannelse",
            },
            startDate: {
                title: "Start dato for uddannelse",
                placeholder: "Hvornår startede du på din uddannelse?",
            },
            endDate: {
                title: "Dato for afsluttet uddannelse",
                placeholder: "Udfyld dato",
            },
            glMember: {
                title: "Er du medlem af GL?",
                description: "Hvis du er medlem af GL, sørger DM for at overflytte dit medlemskab. Hvis du er medlem af en anden fagforening, skal du selv sørge for at melde dig ud.",
                label: "Ja, jeg er medlem af GL - Gymnasielærerne",
            },
            validationMessage: {
                dateMustBeHigher: "skal være senere end startdato.",
            }
        },
        workForm: {
            title: "Arbejde",
            dmEmploymentTypes: {
                freelanceFullTime: "Freelancer fuldtid",
                freelancePartTime: "Freelancer deltid",
                selfEmployed: "Selvstændig",
                fullTime: "Fuld tid (mere end 18 timer/uge)",
                partTime: "Deltid (18 timer/uge eller derunder)",
                flexTime: "Fleksjob",
            },
            dmEmploymentType: {
                title: "Ansættelsestype",
                placeholder: "Vælg ansættelsestype",
            },
            combinator: {
                title: "Er du kombinatør?",
                label: "Ja, jeg arbejder både som freelancer/selvstændig og som lønmodtager"
            },
            workTitle: {
                title: "Titel",
                placeholder: "Indtast titel",
            },
            cvr: {
                title: "CVR-nummer",
                placeholder: "Skriv CVR-nummer",
            },
            workingArea: {
                title: "Arbejdsområde",
                defaultOption: "Vælg arbejdsområde"
            },
            startDate: {
                title: "Startdato",
                placeholder: "Vælg startdato for ansættelsen",
            },
            workplaces: {
                title: "Arbejdsplads",
                placeholder: "Skriv for at søge",
                addLabel: "Tilføj arbejdsplads",
                backLabel: "Tilbage til søgning efter arbejdsplads",
                errorMessage: "Søg og vælg fra listen"
            },
            employedUnderAcAgreement: {
                title: "Er du ansat på AC-overenskomst?",
                label: "Ja, jeg er ansat på AC-overenskomst"
            },
            managerWithPersonnel: {
                title: "Er du leder med personaleansvar?",
                label: "Ja, jeg er leder med personaleansvar"
            },
            jobPosition: {
                title: "Stilling",
                placeholder: "Vælg stilling",
            },
            companyName: {
                title: "Virksomhed",
                placeholder: "Skriv navn på virksomhed",
            },
            companyAddress: {
                title: "Adresse",
                placeholder: "Skriv adresse på virksomheden",
            },
            workplaceName: {
                title: "Arbejdsplads",
                placeholder: "Skriv navn på din arbejdsplads",
            },
            workplaceAddress: {
                title: "Adresse",
                placeholder: "Skriv adresse på din arbejdsplads",
            },
            cvrSearch:{
                workplace:{
                    title: "Der findes flere arbejdspladser i den valgte virksomhed",
                    placeholder: "Vælg din arbejdsplads på listen",
                    label:"Vi fandt en virksomhed med dette CVR-nummer",
                    notFoundLabel: "Kan du ikke finde din arbejdsplads på listen?",
                    backToListLabel: "Se listen over arbejdspladser"
                }
            }
        }
    },
};